export const MAX_CHARACTERS = 50
